import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./online_test.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";

export const ElearningHomeOnlineTest = () => {
  return (
    <section className={styles.section_onlinetest}>
      <div className="container">
        <h2 className={styles.title}>
          Why Enrol for UniSearch’s
          <br />
          Complete{" "}
          <span className={"color-orange"}>IELTS Training Course?</span>
        </h2>

        <Grid container spacing={{ xs: 3, sm: 3, md: 4 }}>
          <Grid item xs={12} sm={6} md={4}>
            <div className={styles.test_card}>
              <Image
                width={56}
                height={56}
                src={getAssets("/assets/images/elearning/ielts-paper.webp")}
                alt="icon"
              />
              <h4 className={styles.test_title}>Practice Real IELTS Papers</h4>
              <div className={styles.test_desc}>
                Learn what to expect with IELTS past papers and practice tests
                simulating the real deal, including Listening section audio
                recordings and one-to-one Speaking sessions
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className={styles.test_card}>
              {/* <ReactSVG
                className={styles.test_icon}
                src="/assets/images/elearning/community-input.svg"
              /> */}
              <Image
                width={56}
                height={56}
                src={getAssets("/assets/images/elearning/community-input.webp")}
                alt="icon"
              />
              <h4 className={styles.test_title}>
                All-Inclusive Community Input
              </h4>
              <div className={styles.test_desc}>
                This course is built with the insight and knowledge of our
                experienced and dedicated community of IELTS trainers,
                counselors, past examiners and exam takers
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <div className={styles.test_card}>
              <Image
                width={56}
                height={56}
                src={getAssets("/assets/images/elearning/analytics-tool.webp")}
                alt="icon"
              />
              <h4 className={styles.test_title}>
                Comprehensive Analytics Tool
              </h4>
              <div className={styles.test_desc}>
                Set target score goals and get real-time feedback of your
                performance to chart your progress and pinpoint areas to improve
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <div className={styles.test_card}>
              <Image
                width={56}
                height={56}
                src={getAssets("/assets/images/elearning/sample-answers.webp")}
                alt="icon"
              />
              <h4 className={styles.test_title}>
                View Practice Scores and Sample Answers with Explanations
              </h4>
              <div className={styles.test_desc}>
                Check your current performance and progress through scored
                practice tests, with sample answers and evaluations to help you
                improve
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className={styles.test_card}>
              <Image
                width={56}
                height={56}
                src={getAssets("/assets/images/elearning/support.webp")}
                alt="icon"
              />
              <h4 className={styles.test_title}>
                All-Around Support to Boost Your Score
              </h4>
              <div className={styles.test_desc}>
                Our expert trainers provide individualised feedback and support
                to each student based on their performance, strengths and
                weaknesses
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className={styles.test_card}>
              <Image
                width={56}
                height={56}
                src={getAssets("/assets/images/elearning/boost-scores.webp")}
                alt="icon"
              />
              <h4 className={styles.test_title}>
                Boost Your IELTS Band Scores
              </h4>
              <div className={styles.test_desc}>
                Finetune your scores for individual IELTS sections with targeted
                practice, guidance and resources to improve your performance
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningHomeOnlineTest;
